<template>
    <div
        v-if="isInit"
        class="patsnap-biz-bio_search_setting"
    >
        <section
            v-if="isActive(settingConfig.algorithmType) && isInBio"
            class="row-space search-preference__alg"
        >
            <h4 class="search-preferences--section__title">
                {{ $t('Search.labels.algorithmType') }}
            </h4>
            <div class="row-space">
                <div class="search-preference__alg-label">
                    <label class="search-preferences--radio">
                        <input
                            v-model="settingConfig.algorithmType.value"
                            :value="MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast"
                            type="radio"
                            @change="handelFieldChange(settingConfig.algorithmType)"
                        >
                        <span class="search-preferences--value">
                            {{ $t('Search.labels.algorithmTypes.Blast') }}
                        </span>
                    </label>
                    <label class="search-preferences--radio">
                        <input
                            v-model="settingConfig.algorithmType.value"
                            :value="MODIFICATION_SEARCH_ALGORITHM_TYPES.NW"
                            type="radio"
                            @change="handelFieldChange(settingConfig.algorithmType)"
                        >
                        <span class="search-preferences--value">
                            {{ $t('Search.labels.algorithmTypes.Nw') }}
                        </span>
                    </label>
                    <ElPopover
                        :visible-arrow="false"
                        :width="458"
                        placement="right"
                        trigger="hover"
                        popper-class="bio-search-setting__popover"
                    >
                        <div class="preferences-propver__container">
                            <div class="preferences-propver__content space-y-2">
                                <p
                                    class="leading-4"
                                    v-html="$t('Search.propver.Preferences.algorithmDescription.1')"
                                />
                                <img :src="safeImagesUrl('globalAlignmentExplanation.1')"/>
                                <p
                                    class="leading-4"
                                    v-html="$t('Search.propver.Preferences.algorithmDescription.2')"
                                />
                                <img :src="safeImagesUrl('globalAlignmentExplanation.2')"/>
                                <p
                                    class="leading-4"
                                    v-html="$t('Search.propver.Preferences.algorithmDescription.3')"
                                />
                            </div>
                        </div>
                        <PtIcon
                            slot="reference"
                            icon="SolidInfo"
                            style="margin-left: 12px"
                        />
                    </ElPopover>
                </div>
            </div>
        </section>
        <template v-if="isNWAlgorithmType && isInBio">
            <h4 class="search-preferences--section__title">
                {{ $t('Search.labels.algorithmSettings') }}
            </h4>
            <section class="search-preferences-new--section w-full">
                <div style="width: 234px">
                    <div
                        v-if="isActive(settingConfig.ungapped)"
                        class="row-space"
                    >
                        <div>
                            <span class="search-preference__title">{{ $t('Search.labels.gaps') }}</span>
                            <ElPopover
                                :visible-arrow="false"
                                :width="366"
                                placement="right"
                                trigger="hover"
                                popper-class="bio-search-setting__popover"
                            >
                                <preferences-propver
                                    :type="'gaps'"
                                    :img-src="safeImagesUrl('ungappedExplanation')"
                                />
                                <PtIcon
                                    slot="reference"
                                    icon="SolidInfo"
                                />
                            </ElPopover>
                        </div>
                        <div
                            class="search-preference__gaps-label"
                        >
                            <label class="search-preferences--radio">
                                <input
                                    v-model="settingConfig.ungapped.value"
                                    :value="true"
                                    type="radio"
                                    @change="handelFieldChange(settingConfig.ungapped)"
                                >
                                <span class="search-preferences--value">{{ $t('Search.labels.yes') }}</span>
                            </label>
                            <label class="search-preferences--radio">
                                <input
                                    v-model="settingConfig.ungapped.value"
                                    :value="false"
                                    type="radio"
                                    @change="handelFieldChange(settingConfig.ungapped)"
                                >
                                <span class="search-preferences--value">{{ $t('Search.labels.no') }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="row-space">
                        <SliderRow
                            v-if="isActive(settingConfig.similarity)"
                            id="test_similarity_slider"
                            :value.sync="settingConfig.similarity.value"
                            :label="$t('Search.labels.similarity')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.similarity, true)"
                        >
                            <template slot="label">
                                <div>
                                    <span>{{ $t('Search.labels.alignmentIdentity') }}</span>
                                    <ElPopover
                                        :visible-arrow="false"
                                        :width="366"
                                        placement="right"
                                        trigger="hover"
                                        popper-class="bio-search-setting__popover"
                                    >
                                        <div class="preferences-propver__container">
                                            <div class="preferences-propver__content">
                                                <img :src="safeImagesUrl('globalAlignmentSimilarityExplanation')" />
                                                <div class="flex items-center text-xs mt-2 text-black-default">
                                                    <span class="mr-1">
                                                        {{ $t('Search.labels.alignmentIdentity') }}
                                                    </span>
                                                    <span class="mx-2"> = </span>
                                                    <span class="inline-flex flex-col text-center">
                                                        <span class="px-1 mb-1">
                                                            {{ $t('Search.explanation.identityLength') }}
                                                        </span>
                                                        <span class="bg-black-default h-[1px]" />
                                                        <span class="px-1 mt-1">
                                                            {{ $t('Search.explanation.alignLength') }}
                                                        </span>
                                                    </span>
                                                    <span class="mx-2"> = </span>
                                                    <span class="inline-flex flex-col text-center">
                                                        <span class="px-1 mb-1">4</span>
                                                        <span class="bg-black-default h-[1px]" />
                                                        <span class="px-1 mt-1">8</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <PtIcon
                                            slot="reference"
                                            icon="SolidInfo"
                                            class="ml-2"
                                        />
                                    </ElPopover>
                                </div>
                            </template>
                        </SliderRow>
                    </div>
                    <div
                        v-if="isActive(settingConfig.gapExtend)"
                        class="row-space"
                    >
                        <div>
                            <span class="search-preference__title">
                                {{ $t('Search.labels.gapExtend') }}
                            </span>
                        </div>
                        <ElInputNumber
                            v-model="settingConfig.gapExtend.value"
                            class="search-preferences--number-input"
                            size="small"
                            :precision="0"
                            :min="0"
                            @keypress="isNumber($event)"
                            @change="handelFieldChange(settingConfig.gapExtend)"
                        />
                    </div>
                    <div
                        v-if="isActive(settingConfig.gapOpen)"
                        class="row-space"
                    >
                        <div>
                            <span class="search-preference__title">
                                {{ $t('Search.labels.gapOpen') }}
                            </span>
                        </div>
                        <ElInputNumber
                            v-model="settingConfig.gapOpen.value"
                            class="search-preferences--number-input"
                            size="small"
                            :precision="0"
                            :min="0"
                            @keypress="isNumber($event)"
                            @change="handelFieldChange(settingConfig.gapOpen)"
                        />
                    </div>
                    <div
                        v-if="isActive(settingConfig.scoreMatrix)"
                        class="row-space"
                    >
                        <div>
                            <span class="search-preference__title">
                                {{ $t('Search.labels.scoreMatrix') }}
                            </span>
                        </div>
                        <div>
                            <ElSelect
                                v-model="settingConfig.scoreMatrix.value"
                                class="search-preference__select"
                                size="small"
                                @change="handelFieldChange(settingConfig.scoreMatrix)"
                            >
                                <ElOption
                                    v-for="name in ScoreMatrixOptions"
                                    :key="name"
                                    :value="name"
                                >
                                    {{ name }}
                                </ElOption>
                            </ElSelect>
                        </div>
                    </div>
                    <div
                        v-if="isActive(settingConfig.targetSeqLimit)"
                        class="row-space"
                    >
                        <div>
                            <span class="search-preference__title">
                                {{ $t('Search.labels.targetSeqLimit') }}
                            </span>
                        </div>
                        <div>
                            <ElSelect
                                id="target_seq_limit_select"
                                v-model="settingConfig.targetSeqLimit.value"
                                class="search-preference__select"
                                size="small"
                                @change="(value) => {
                                    updateUserSetting({ key: 'limit', value });
                                }"
                            >
                                <ElOption
                                    v-for="option in targetSeqLimitOptionsFinal"
                                    :key="option.value"
                                    :value="option.value"
                                    :disabled="option.disabled"
                                >
                                    <ElTooltip
                                        v-if="option.tooltip"
                                        placement="right-start"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="option.tooltip"
                                    >
                                        <span>{{ option.label }}</span>
                                    </ElTooltip>
                                    <span v-else>
                                        {{ option.label }}
                                    </span>
                                </ElOption>
                            </ElSelect>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <template v-else>
            <section
                v-if="!isAntibody && !isCdr && !externalDbTypeSeqType"
                class="row-space"
            >
                <h4 class="search-preferences--section__title">
                    {{ $t('Search.labels.databaseTitle') }}
                </h4>
                <div class="search-preferences-new--section">
                    <div
                        class="search-preferences-database"
                        :class="{ 'block': isMotif2 }"
                    >
                        <div class="search-preferences-database__item">
                            <div class="search-summary__field">
                                {{ $t('Search.labels.predicted') }}
                            </div>
                            <div
                                class="search-summary__block"
                            >
                                <div
                                    v-for="t in SEQUENCE_TYPES"
                                    :key="t"
                                    class="search-summary__option"
                                >
                                    <label>
                                        <input
                                            v-model="settingConfig.sequenceType.value"
                                            :value="t"
                                            type="radio"
                                            @change="updateSequenceType"
                                        >
                                        <span>
                                            {{ $t(`Search.btns.${t.toLowerCase()}`) }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="search-preferences-database__item">
                            <div class="search-summary__field">
                                {{ $t('Search.labels.database') }}
                            </div>
                            <div
                                v-if="(isSequence || isShort) && !radioDbType"
                                class="search-summary__block"
                            >
                                <div
                                    v-for="t in DATABASE_TYPES"
                                    :key="t"
                                    class="search-summary__option"
                                >
                                    <label>
                                        <input
                                            v-model="multiDbType"
                                            :value="t"
                                            :disabled="multiDbType.length === 1 && multiDbType[0] === t"
                                            type="checkbox"
                                            name="dbType"
                                            @change="handleChangeMultipleDbType"
                                        >
                                        <span>{{ $t(`Search.btns.${t.toLowerCase()}`) }}</span>
                                    </label>
                                </div>
                            </div>
                            <div
                                v-else
                                class="search-summary__block"
                            >
                                <div
                                    v-for="t in DATABASE_TYPES"
                                    :key="t"
                                    class="search-summary__option"
                                >
                                    <label>
                                        <input
                                            v-model="settingConfig.dbType.value"
                                            :value="t"
                                            :disabled="isMotif"
                                            type="radio"
                                            @change="updateDbType"
                                        >
                                        <span>{{ $t(`Search.btns.${t.toLowerCase()}`) }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isInBio && !externalDbTypeSeqType && isSlowSearch"
                    class="slow-warning"
                >
                    <PtIcon icon="SolidWarning" />
                    <span>{{ $t('Search.propver.Preferences.slowWarning') }}</span>
                </div>
            </section>
            <div
                class="search-preferences-new--container__main"
            >
                <div class="search-preferences-new--item">
                    <h4 class="search-preferences--section__title">
                        {{ $t('Search.labels.searchParameters') }}
                    </h4>
                    <section class="search-preferences-new--section fit-parent-height">
                        <!-- subject length -->
                        <div
                            v-if="isActive(settingConfig.sequenceLength) || isActive(settingConfig.multiSequenceLength)"
                            class="row-space"
                        >
                            <div>
                                <span
                                    v-if="!isMultiDbType"
                                    class="search-preference__title"
                                >
                                    {{ $t('Search.labels.subjectLength') }}
                                </span>
                                <div
                                    v-else
                                    class="search-preference__title--multi"
                                >
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.subjectNucLength') }}
                                    </span>
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.subjectProteinLength') }}
                                    </span>
                                </div>
                            </div>
                            <div
                                class="search-preference__gaps-label"
                            >
                                <div
                                    v-if="!isMultiDbType"
                                    class="common-range"
                                >
                                    <div
                                        class="common-range-group"
                                    >
                                        <input
                                            :value="settingConfig.sequenceLength.value[0]"
                                            :maxlength="9"
                                            class="common-range-group__input"
                                            style="text-align:right"
                                            type="text"
                                            @keypress="isNumber($event)"
                                            @blur="onStartChange"
                                        >
                                        <div class="common-range-group__separator" />
                                        <input
                                            :value="settingConfig.sequenceLength.value[1]"
                                            :maxlength="9"
                                            placeholder="∞"
                                            class="common-range-group__input"
                                            type="text"
                                            style="text-align:left"
                                            @keypress="isNumber($event)"
                                            @blur="onEndChange"
                                        >
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="common-range--multi"
                                >
                                    <div
                                        class="common-range"
                                    >
                                        <div
                                            class="common-range-group"
                                        >
                                            <input
                                                :value="settingConfig.multiSequenceLength.value.nucleotide[0]"
                                                :maxlength="9"
                                                class="common-range-group__input sequence"
                                                style="text-align:right"
                                                type="text"
                                                @keypress="isNumber($event)"
                                                @blur="onMultiNucStartChange"
                                            >
                                            <div class="common-range-group__separator" />
                                            <input
                                                :value="settingConfig.multiSequenceLength.value.nucleotide[1]"
                                                :maxlength="9"
                                                placeholder="∞"
                                                class="common-range-group__input sequence"
                                                type="text"
                                                style="text-align:left"
                                                @keypress="isNumber($event)"
                                                @blur="onMultiNucEndChange"
                                            >
                                        </div>
                                    </div>
                                    <div
                                        class="common-range"
                                    >
                                        <div
                                            class="common-range-group"
                                        >
                                            <input
                                                :value="settingConfig.multiSequenceLength.value.protein[0]"
                                                :maxlength="9"
                                                class="common-range-group__input sequence"
                                                style="text-align:right"
                                                type="text"
                                                @keypress="isNumber($event)"
                                                @blur="onMultiProteinStartChange"
                                            >
                                            <div class="common-range-group__separator" />
                                            <input
                                                :value="settingConfig.multiSequenceLength.value.protein[1]"
                                                :maxlength="9"
                                                placeholder="∞"
                                                class="common-range-group__input sequence"
                                                type="text"
                                                style="text-align:left"
                                                @keypress="isNumber($event)"
                                                @blur="onMultiProteinEndChange"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SliderRow
                            v-if="isActive(settingConfig.similarity)"
                            id="test_similarity_slider"
                            :value.sync="settingConfig.similarity.value"
                            :label="$t('Search.labels.similarity')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.similarity, true)"
                        >
                            <div slot="label">
                                <span>{{ $t('Search.labels.similarity') }}</span>
                                <ElPopover
                                    placement="right"
                                    trigger="hover"
                                    :visible-arrow="false"
                                >
                                    <AlignmentExplanation
                                        :img-src="safeImagesUrl('similarityExplanation')"
                                    />
                                    <PtIcon
                                        slot="reference"
                                        icon="SolidInfo"
                                    />
                                </ElPopover>
                            </div>
                        </SliderRow>
                        <SliderRow
                            v-if="isActive(settingConfig.querySimilarity)"
                            id="test_query_similarity_slider"
                            :value.sync="settingConfig.querySimilarity.value"
                            :label="$t('Search.labels.queryIdentity')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.querySimilarity, true)"
                        />
                        <SliderRow
                            v-if="isActive(settingConfig.queryCoverage)"
                            id="test_query_coverage_slider"
                            :value.sync="settingConfig.queryCoverage.value"
                            :label="$t('Search.labels.qconv')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.queryCoverage, true)"
                        />
                        <SliderRow
                            v-if="isActive(settingConfig.subjectSimilarity)"
                            id="test_subject_similarity_slider"
                            :value.sync="settingConfig.subjectSimilarity.value"
                            :label="$t('Search.labels.subjectIdentity')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.subjectSimilarity, true)"
                        />
                        <SliderRow
                            v-if="isActive(settingConfig.subjectCoverage)"
                            id="test_subject_coverage_slider"
                            :value.sync="settingConfig.subjectCoverage.value"
                            :label="$t('Search.labels.subjectCoverage')"
                            class="row-space"
                            @update:value="handelFieldChange(settingConfig.subjectCoverage, true)"
                        />
                        <div
                            v-if="isActive(settingConfig.targetSeqLimit) && isInBio && externalDbTypeSeqType"
                            class="row-space"
                        >
                            <div>
                                <span class="search-preference__title">
                                    {{ $t('Search.labels.targetSeqLimit') }}
                                </span>
                            </div>
                            <div>
                                <ElSelect
                                    id="target_seq_limit_select"
                                    v-model="settingConfig.targetSeqLimit.value"
                                    class="search-preference__select"
                                    size="small"
                                    @change="(value) => {
                                        updateUserSetting({ key: 'limit', value });
                                    }"
                                >
                                    <ElOption
                                        v-for="option in targetSeqLimitOptionsFinal"
                                        :key="option.value"
                                        :value="option.value"
                                        :disabled="option.disabled"
                                    >
                                        <ElTooltip
                                            v-if="option.tooltip"
                                            placement="right-start"
                                            effect="light"
                                            :visible-arrow="false"
                                            :content="option.tooltip"
                                        >
                                            <span>{{ option.label }}</span>
                                        </ElTooltip>
                                        <span v-else>
                                            {{ option.label }}
                                        </span>
                                    </ElOption>
                                </ElSelect>
                            </div>
                        </div>
                    </section>
                </div>
                <div
                    v-if="!isMotif2 && !isFragment"
                    class="search-preferences-new--item"
                >
                    <h4 class="search-preferences--section__title">
                        {{ $t('Search.labels.algorithmSettings') }}
                    </h4>
                    <section class="search-preferences-new--section">
                        <div
                            v-if="isActive(settingConfig.ungapped)"
                            class="row-space"
                        >
                            <div>
                                <span class="search-preference__title">{{ $t('Search.labels.gaps') }}</span>
                                <ElPopover
                                    :visible-arrow="false"
                                    :width="366"
                                    placement="right"
                                    trigger="hover"
                                    popper-class="bio-search-setting__popover"
                                >
                                    <preferences-propver
                                        :type="'gaps'"
                                        :img-src="safeImagesUrl('ungappedExplanation')"
                                    />
                                    <PtIcon
                                        slot="reference"
                                        icon="SolidInfo"
                                    />
                                </ElPopover>
                            </div>
                            <div
                                class="search-preference__gaps-label"
                            >
                                <label class="search-preferences--radio">
                                    <input
                                        v-model="settingConfig.ungapped.value"
                                        :value="true"
                                        type="radio"
                                        @change="handelFieldChange(settingConfig.ungapped)"
                                    >
                                    <span class="search-preferences--value">{{ $t('Search.labels.yes') }}</span>
                                </label>
                                <label class="search-preferences--radio">
                                    <input
                                        v-model="settingConfig.ungapped.value"
                                        :value="false"
                                        type="radio"
                                        @change="handelFieldChange(settingConfig.ungapped)"
                                    >
                                    <span class="search-preferences--value">{{ $t('Search.labels.no') }}</span>
                                </label>
                            </div>
                        </div>
                    </section>
                    <div v-if="!isMultiDbType && isShowAlgorithm">
                        <h4
                            v-if="isActive(settingConfig.defaultAlgorithm)"
                            class="search-preferences--section__title"
                            style="margin-top: 16px"
                        >
                            <div>
                                <PtCheckbox
                                    v-model="settingConfig.defaultAlgorithm.value"
                                    @change="handleAlgorithmFieldsChange(settingConfig.defaultAlgorithm)"
                                >
                                    {{ $t('Search.labels.defaultAlgorithm') }}
                                </PtCheckbox>
                                <ElPopover
                                    placement="right"
                                    trigger="hover"
                                    :visible-arrow="false"
                                    :width="366"
                                    popper-class="bio-search-setting__popover"
                                >
                                    <div>{{ $t('Search.propver.Preferences.defaultAlgorithm') }}</div>
                                    <PtIcon
                                        slot="reference"
                                        icon="SolidInfo"
                                    />
                                </ElPopover>
                            </div>
                        </h4>
                        <section
                            v-if="isShort"
                            class="search-preferences-new--section"
                        >
                            <div
                                v-if="isActive(settingConfig.wordSize)"
                                class="row-space"
                            >
                                <div :span="10">
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.wordSize') }}({{ $t('Search.labels.wordSizeHold') }})
                                    </span>
                                </div>
                                <div :span="14">
                                    <ElSelect
                                        id="test_short_word_size_select"
                                        v-model="settingConfig.wordSize.value"
                                        placeholder="Word size"
                                        class="search-preference__select"
                                        size="small"
                                        @change="handleAlgorithmFieldsChange(settingConfig.wordSize)"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.wordSize.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                </div>
                            </div>
                        </section>
                        <section
                            v-if="isActive(settingConfig.algorithm)"
                            class="search-preferences-new--section"
                            :class="{ 'mt16': !isActive(settingConfig.defaultAlgorithm) }"
                        >
                            <div
                                class="row-space"
                            >
                                <div>
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.algorithm') }}
                                        <ElPopover
                                            placement="right"
                                            trigger="hover"
                                            :visible-arrow="false"
                                            :width="366"
                                            popper-class="bio-search-setting__popover"
                                        >
                                            <algorithm-popover :options="settingConfig.algorithm.options" />
                                            <PtIcon
                                                slot="reference"
                                                icon="SolidInfo"
                                            />
                                        </ElPopover>
                                    </span>
                                </div>
                                <div class="row-space">
                                    <ElSelect
                                        v-if="settingConfig.algorithm.options.length > 1"
                                        id="test_algorithm_select"
                                        v-model="settingConfig.algorithm.value"
                                        class="search-preference__select"
                                        :disabled="settingConfig.defaultAlgorithm.value"
                                        size="small"
                                        @change="handleAlgorithmChange(settingConfig.algorithm)"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.algorithm.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                    <span
                                        v-else
                                        class="search-preference__optionText"
                                    >
                                        {{ settingConfig.algorithm.options[0].label }}
                                    </span>
                                </div>
                            </div>
                            <!-- row -->
                            <div
                                v-if="isActive(settingConfig.matrix)"
                                class="row-space"
                            >
                                <div>
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.matrix') }}
                                    </span>
                                </div>
                                <div>
                                    <ElSelect
                                        id="test_matrix_select"
                                        v-model="settingConfig.matrix.value"
                                        placeholder="Scoring matrix"
                                        class="search-preference__select"
                                        :disabled="settingConfig.defaultAlgorithm.value"
                                        size="small"
                                        @change="handleChangeMatrix"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.matrix.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                </div>
                            </div>
                            <!-- /row -->
                            <!-- row -->
                            <div
                                v-if="isActive(settingConfig.wordSize)"
                                class="row-space"
                            >
                                <div :span="10">
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.wordSize') }}({{ $t('Search.labels.wordSizeHold') }})
                                    </span>
                                </div>
                                <div :span="14">
                                    <ElSelect
                                        id="test_word_size_select"
                                        v-model="settingConfig.wordSize.value"
                                        placeholder="Word size"
                                        class="search-preference__select"
                                        :disabled="settingConfig.defaultAlgorithm.value"
                                        size="small"
                                        @change="handleAlgorithmFieldsChange(settingConfig.wordSize)"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.wordSize.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                </div>
                            </div>
                            <!-- /row -->

                            <!-- row -->
                            <div
                                v-if="isActive(settingConfig.matchScores)"
                                class="row-space"
                            >
                                <div>
                                    <!-- eslint-disable-next-line -->
                                    <div v-html="$t('Search.labels.matchScores')" />
                                </div>
                                <div>
                                    <ElSelect
                                        id="test_math_scores_select"
                                        v-model="settingConfig.matchScores.value"
                                        placeholder="matchScores"
                                        class="search-preference__select"
                                        :disabled="settingConfig.defaultAlgorithm.value"
                                        size="small"
                                        @change="handleChangeMatchScores"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.matchScores.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                </div>
                            </div>
                            <!-- /row -->

                            <!-- row -->
                            <div
                                v-if="isActive(settingConfig.gaps)"
                                class="row-space"
                            >
                                <div>
                                    <span class="search-preference__title">
                                        {{ $t('Search.labels.gapCosts') }}
                                    </span>
                                </div>
                                <div>
                                    <ElSelect
                                        id="test_gaps_select"
                                        v-model="settingConfig.gaps.value"
                                        :disabled="settingConfig.defaultAlgorithm.value"
                                        placeholder="Gap costs"
                                        class="search-preference__select"
                                        size="small"
                                        @change="handleAlgorithmFieldsChange(settingConfig.gaps)"
                                    >
                                        <ElOption
                                            v-for="option in settingConfig.gaps.options"
                                            :key="option.value"
                                            :label="option.label"
                                            :value="option.value"
                                        />
                                    </ElSelect>
                                </div>
                            </div>
                            <!-- /row -->
                        </section>
                    </div>
                </div>
            </div>
        </template>
        <div class="search-preference__reset">
            <button
                class="pt-ui-btn"
                @click="resetPreferenceSet"
            >
                {{ $t('Search.propver.reset') }}
            </button>
        </div>
    </div>
</template>

<script>
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import Popover from 'element-ui/lib/popover';
import Checkbox from 'element-ui/lib/checkbox';
import Tooltip from 'element-ui/lib/tooltip';
import InputNumber from 'element-ui/lib/input-number';
import PtIcon from '@patsnap-biz/icon';
import PreferencesPropver from './explanations/PreferencesPropver.vue';
import AlgorithmPopover from './explanations/AlgorithmPopover.vue';
import SliderRow from './components/SliderRow';
import AlignmentExplanation from './explanations/AlignmentExplanation.vue';
import mixin from './DEPRECATED_BioSearchSetting';

// 完全废弃，但是留作参考

export default {
    name: 'PtBioSearchSetting',
    components: {
        PreferencesPropver,
        AlgorithmPopover,
        SliderRow,
        ElSelect: Select,
        ElOption: Option,
        ElPopover: Popover,
        ElTooltip: Tooltip,
        ElInputNumber: InputNumber,
        PtCheckbox: Checkbox,
        PtIcon,
        AlignmentExplanation,
    },
    mixins: [mixin],
};
</script>
